module.exports = __webpack_public_path__ + "img/ic_delete.45a23fd9.svg";